// extracted by mini-css-extract-plugin
module.exports = {"dropdown":"Dropdown_dropdown_2-GFR","trigger":"Dropdown_trigger_2Z0Q5","dropdownFont":"Dropdown_dropdownFont_12UVm","spinAround":"Dropdown_spinAround_7_bCX"};